module.exports = __webpack_public_path__ + "assets/media/images/service-link-logo.12ee7db3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/images/service-link-logo.png
// module id = 1351
// module chunks = 3